<template>

    <cms-view v-spinner="loading">

        <div v-if="repair">
            <cms-heading :title="pageTitle">
                <cms-button icon="magicon-pencil" :to="{ name: 'repair-edit', params: { id: repair.id }}">Wijzigen</cms-button>
                <cms-button icon="magicon-jump-right-up" @click="exportRepair">Exporteren (CSV)</cms-button>
            </cms-heading>

            <cms-view-panel>
                <tr>
                    <td class="key">Referentie</td>
                    <td>{{ repair.reference }}</td>
                </tr>
                <tr>
                    <td class="key">Startdatum</td>
                    <td>{{ repair.startDate | date('LL') }}</td>
                </tr>
                <tr>
                    <td class="key">Einddatum</td>
                    <td>{{ repair.endDate | date('LL') }}</td>
                </tr>
                <tr>
                    <td class="key">Aantal loggers</td>
                    <td>{{ repair.loggers.itemCount }}</td>
                </tr>
            </cms-view-panel>

            <cms-heading title="Loggers" level="2">
                <cms-button color="highlight-1" icon="magicon-ok" :disabled="selectedLoggers.length == 0" @click="makeSelection">Selectie maken ({{ selectedLoggers.length }})</cms-button>
                <cms-button color="default-dark" icon="magicon-close" :disabled="selectedLoggers.length == 0" @click="resetSelection">Reset selectie</cms-button>
            </cms-heading>
            <cms-table-panel v-spinner="loading" :placeholder="!repair.loggers.items || !repair.loggers.items.length" show-count="true" clickable="true">
                <cms-table-header>
                    <cms-th field="serialNumber" v-model="loggersSort">Serienummer</cms-th>
                    <cms-th field="typeId" v-model="loggersSort">Type</cms-th>
                    <cms-th field="state" v-model="loggersSort">Status</cms-th>
                    <cms-th field="owner" v-model="loggersSort">Eigendom</cms-th>
                    <cms-th>Opmerkingen</cms-th>
                    <cms-th style="width: 40px;"><cms-checkbox @input="toggleSelection" :checked="repair.loggers.items && selectedLoggers.length == repair.loggers.items.length"></cms-checkbox></cms-th>
                </cms-table-header>
                <tr v-for="logger in repair.loggers.items" :class="{ selected: isSelected(logger) }" @click="showLogger(logger)">
                    <td>{{ logger.serialNumber }}</td>
                    <td>{{ logger.type.title }}</td>
                    <td><cms-text-label :title="logger.state | loggerState" :color="logger.state | loggerStateColor" /></td>
                    <td>{{ logger.owner }}</td>
                    <td>{{ logger.latestMutation ? logger.latestMutation.comments : '' }}</td>
                    <td @click.stop><cms-checkbox :checked="isSelected(logger)" @input="updateSelection(logger, arguments[0])"></cms-checkbox></td>
                </tr>
            </cms-table-panel>
        </div>

    </cms-view>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'
    import di from 'di'
    import gql from 'graphql-tag'

    import without from 'lodash/without'

    import RepairQueries from 'app/queries/RepairQueries'

    @Component({

        name: 'view-repair',
        apollo: {

            repair: RepairQueries.find({

                fetchPolicy: 'cache-and-network',

                variables(){

                    return {
                        repairId: this.repairId,
                        loggersOffset: null,
                        loggersLimit: null,
                        loggersSortField: this.loggersSort.field,
                        loggersSortDirection: this.loggersSort.direction
                    }
                }
            })
        }
    })
    export default class extends Vue
    {
        data(){

            return {

                loading: 0,
                repair: null,

                selectedLoggers: [],
                loggersSort: {
                    field: 'serialNumber',
                    direction: 'ASC'
                }
            }
        }

        breadcrumb(){

            return [{
                title: 'Reparaties',
                route: {
                    name: 'repairs'
                }
            }, this.pageTitle];
        }

        get pageTitle(){

            return this.repair ? `Reparatie ${this.repair.reference}` : ''
        }

        get repairId(){

            return this.$route.params.id;
        }

        onQueryError(){

            this.$toast.error('De reparatie kon niet worden opgehaald');
        }

        updateSelection(logger, selected){

            if(selected) {
                this.selectedLoggers.push(logger);
            }
            else {
                this.selectedLoggers = without(this.selectedLoggers, logger);
            }
        }

        isSelected(logger){

            return this.selectedLoggers.indexOf(logger) != -1;
        }

        toggleSelection(selected){

            if(selected){

                this.selectedLoggers = this.repair.loggers.items;
            }
            else {

                this.selectedLoggers = [];
            }
        }

        resetSelection(){

            this.selectedLoggers = [];
        }

        makeSelection(){

            if(this.selectedLoggers.length == 0){
                return;
            }

            di.set('selectedLoggers', this.selectedLoggers);
            this.$router.push({ name: 'select-loggers' });
        }

        showLogger(logger){

            this.$router.push({
                name: 'logger-view',
                params: { id: logger.id }
            });
        }

        exportRepair(){

            window.open(this.$config.apiUrl + '/export/csv/repair/' + this.repairId);
        }
    }

</script>